import AdminHotelView from './admin-hotel-view-component';
import AdminHotelViewService from './admin-hotel-view-service';
import AdminHotelSettingsModule from './admin-hotel-settings/admin-hotel-settings-module';

import './admin-hotel-view.scss';

const MODULE_NAME = 'App.admin.hotel-view';
const module = angular
    .module(MODULE_NAME, [
        'app.constants',
        'app.admin.states',
        AdminHotelSettingsModule,
    ])
    .directive(AdminHotelView.DIRECTIVE_NAME, AdminHotelView)
    .service('adminHotelViewService', AdminHotelViewService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-view/admin-hotel-view-module.js